// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #f5f7fa;
  font-size: 16px;
}

.App {
  min-height: 100vh;
  margin: 0;
  padding: 0;
}

/* Common button styles */
button {
  cursor: pointer;
  font-family: inherit;
}

/* Common form styles */
input,
select,
textarea {
  font-family: inherit;
  font-size: 1rem;
}

textarea {
  font-family: inherit;
  font-size: 1rem;
}

/* Global fix for select dropdown cursor */
select {
  cursor: pointer !important;
}

select option {
  cursor: pointer !important;
}

/* Force cursor on all select elements and their options */
* select,
* select option,
* select:hover,
* select:focus {
  cursor: pointer !important;
}

/* Most specific targeting */
html body select option,
html body select:hover option,
html body select:focus option {
  cursor: pointer !important;
}

/* Common container styles */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

/* Utility classes */
.text-center {
  text-align: center;
}

.mt-1 {
  margin-top: 0.5rem;
}

.mt-2 {
  margin-top: 1rem;
}

.mt-3 {
  margin-top: 1.5rem;
}

.mt-4 {
  margin-top: 2rem;
}

.mb-1 {
  margin-bottom: 0.5rem;
}

.mb-2 {
  margin-bottom: 1rem;
}

.mb-3 {
  margin-bottom: 1.5rem;
}

.mb-4 {
  margin-bottom: 2rem;
}

/* Theme colors */
:root {
  --primary-color: #0d47a1;
  --primary-light: #5472d3;
  --primary-dark: #002171;
  --secondary-color: #e3f2fd;
  --text-on-primary: #ffffff;
  --text-on-secondary: #0d47a1;
  --error-color: #f44336;
  --success-color: #4caf50;
  --warning-color: #ff9800;
  --info-color: #2196f3;
  --background-color: #f5f7fa;
  --card-color: #ffffff;
  --border-color: #dddddd;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4DAA4D;EAC5D,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;;;EAGE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,0DAA0D;AAC1D;;;;EAIE,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;;;EAGE,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n}\n\nbody {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  line-height: 1.6;\n  color: #333;\n  background-color: #f5f7fa;\n  font-size: 16px;\n}\n\n.App {\n  min-height: 100vh;\n  margin: 0;\n  padding: 0;\n}\n\n/* Common button styles */\nbutton {\n  cursor: pointer;\n  font-family: inherit;\n}\n\n/* Common form styles */\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: 1rem;\n}\n\ntextarea {\n  font-family: inherit;\n  font-size: 1rem;\n}\n\n/* Global fix for select dropdown cursor */\nselect {\n  cursor: pointer !important;\n}\n\nselect option {\n  cursor: pointer !important;\n}\n\n/* Force cursor on all select elements and their options */\n* select,\n* select option,\n* select:hover,\n* select:focus {\n  cursor: pointer !important;\n}\n\n/* Most specific targeting */\nhtml body select option,\nhtml body select:hover option,\nhtml body select:focus option {\n  cursor: pointer !important;\n}\n\n/* Common container styles */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n\n/* Utility classes */\n.text-center {\n  text-align: center;\n}\n\n.mt-1 {\n  margin-top: 0.5rem;\n}\n\n.mt-2 {\n  margin-top: 1rem;\n}\n\n.mt-3 {\n  margin-top: 1.5rem;\n}\n\n.mt-4 {\n  margin-top: 2rem;\n}\n\n.mb-1 {\n  margin-bottom: 0.5rem;\n}\n\n.mb-2 {\n  margin-bottom: 1rem;\n}\n\n.mb-3 {\n  margin-bottom: 1.5rem;\n}\n\n.mb-4 {\n  margin-bottom: 2rem;\n}\n\n/* Theme colors */\n:root {\n  --primary-color: #0d47a1;\n  --primary-light: #5472d3;\n  --primary-dark: #002171;\n  --secondary-color: #e3f2fd;\n  --text-on-primary: #ffffff;\n  --text-on-secondary: #0d47a1;\n  --error-color: #f44336;\n  --success-color: #4caf50;\n  --warning-color: #ff9800;\n  --info-color: #2196f3;\n  --background-color: #f5f7fa;\n  --card-color: #ffffff;\n  --border-color: #dddddd;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
